import React, {useState, useEffect} from 'react';
import Link from 'gatsby-link';
import {graphql} from 'gatsby';

import Helmet from 'react-helmet';
import {getCurrentLangKey, getLangs, getUrlForLang} from 'ptz-i18n';
import {IntlProvider, addLocaleData} from 'react-intl';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SiteSearch from "../components/SiteSearch";

import 'intl';
import en from 'react-intl/locale-data/en';
import 'intl/locale-data/jsonp/en';
import es from 'react-intl/locale-data/es';
import 'intl/locale-data/jsonp/es';

import '../styles/index.scss';

// add concatenated locale data
addLocaleData([...en, ...es]);

const TemplateWrapper = ({data, location, children}) => {
  const url = location.pathname;
  const {langs, defaultLangKey} = data.site.siteMetadata.languages;
  const langKey = getCurrentLangKey(langs, defaultLangKey, url);
  const homeLink = `/${langKey}/`;
  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url));

  // get the appropriate message file based on langKey
  // at the moment this assumes that langKey will provide us
  // with the appropriate language code
  const i18nMessages = require(`../data/messages/${langKey}`);

  return (
    <IntlProvider locale={langKey} messages={i18nMessages}>
      <div id="outermost">
        <Helmet
          title="ImmigrationInfo.org"
          meta={[
            { name: "description", content: "Sample" },
            { name: "keywords", content: "sample, something" },
          ]}
        />
        <Header langs={langsMenu} />
        <div id="content-wrapper">
          <main>{children}</main>
        </div>
        <Footer />
      </div>
    </IntlProvider>
  );
};

export default TemplateWrapper;
